export default __webpack_public_path__ + "static/char-sp03-9e29f124131f9f3308a038851c8d28e3.webp";